module.exports = __webpack_public_path__ + "img/12.3395e8b1.svg";